import '@fontsource/cairo/700.css';
import '@fontsource/noto-sans/400.css';
import '@fontsource/noto-sans/600.css';
import '@fontsource/noto-sans/700.css';
import '@fontsource/open-sans/600.css';
import '@fontsource/poppins/500.css';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { useEffect } from 'react';
import { HashRouter, Route, Routes } from 'react-router-dom';
import getInitData from './actions/getInitData';
import getKitTypeCategories from './actions/getKitTypeCategories';
import getKitTypes from './actions/getKitTypes';
import getMembers from './actions/getMembers';
import api from './api/api';
import Page from './components/Page';
import theme from './consts/Theme';
import AuthLoadingPage from './pages/AuthLoadingPage';
import ConfirmPasswordChangePage from './pages/ConfirmPasswordChangePage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import LoginFormPage from './pages/LoginFormPage';
import ConfirmPhonePage from './pages/registration/ConfirmPhonePage';
import RegisterFormPage from './pages/registration/RegisterFormPage';
import UpdateEmailPage from './pages/registration/UpdateEmailPage';
import useStore from './store/store';

function App(props) {
    const siteName = 'Lifespan Genome Portal';
    const setCountries = useStore((state) => state.setCountries);
    const setLoading = useStore((state) => state.setLoading);
    const setFormError = useStore((state) => state.setFormError);
    const setInitialized = useStore((state) => state.setInitialized);
    const { isInitialized } = useStore();

    useEffect(() => {
        const fetchInitialData = async () => {
            await Promise.all([
                getInitData(),
                getMembers(),
                getKitTypes(),
                getKitTypeCategories(),
            ]);
            setInitialized(true);
        };

        fetchInitialData();
    }, [setInitialized]);

    // Effects.
    useEffect(() => {
        // API call.
        const fetchCountries = async () => {
            console.info('Fetching countries');
            setLoading(true);
            try {
                const response = await api.post('/security/get-countries');
                if (response.data.success) {
                    setCountries(response.data.countries);
                    setLoading(false);
                } else {
                    // TODO: Implement.
                    setLoading(false);
                }
            } catch (error) {
                console.error(error);
                // Network Error (error code 17)
                if (error.code) setFormError(error.code);
            }
        };
        fetchCountries();
    }, [setLoading, setFormError, setCountries]);

    return (
        isInitialized && (
            <MuiThemeProvider theme={theme}>
                <HashRouter>
                    <Routes>
                        <Route
                            path="/login"
                            element={
                                <Page title={`${siteName} - Sign In`}>
                                    <LoginFormPage />
                                </Page>
                            }
                        />
                        <Route
                            path="/register"
                            element={
                                <Page title={`${siteName} - Sign Up`}>
                                    <RegisterFormPage />
                                </Page>
                            }
                        />
                        <Route
                            path="/confirm"
                            element={
                                <Page title={`${siteName} - Confirmation`}>
                                    <ConfirmPhonePage />
                                </Page>
                            }
                        />
                        <Route
                            path="/update-email"
                            element={
                                <Page title={`${siteName} - Update Email`}>
                                    <UpdateEmailPage />
                                </Page>
                            }
                        />
                        <Route
                            path="/forgot-password"
                            element={
                                <Page title={`${siteName} - Password Reset`}>
                                    <ForgotPasswordPage />
                                </Page>
                            }
                        />
                        <Route
                            path="/confirm-password-change"
                            element={
                                <Page title={`${siteName} - Confirmation`}>
                                    <ConfirmPasswordChangePage />
                                </Page>
                            }
                        />
                        <Route path="*" element={<AuthLoadingPage />} />
                    </Routes>
                </HashRouter>
            </MuiThemeProvider>
        )
    );
}

export default App;
